__turbopack_context__.v({
  "accountButton": "SidebarAccount-module__tbYnFa__accountButton",
  "accountChevron": "SidebarAccount-module__tbYnFa__accountChevron",
  "accountData": "SidebarAccount-module__tbYnFa__accountData",
  "accountPopover": "SidebarAccount-module__tbYnFa__accountPopover",
  "accountPopoverElement": "SidebarAccount-module__tbYnFa__accountPopoverElement",
  "accountPopoverSeparator": "SidebarAccount-module__tbYnFa__accountPopoverSeparator",
  "activeItem": "SidebarAccount-module__tbYnFa__activeItem",
  "avatarImg": "SidebarAccount-module__tbYnFa__avatarImg",
  "collapsedAccount": "SidebarAccount-module__tbYnFa__collapsedAccount",
  "collapsedAccountWrapper": "SidebarAccount-module__tbYnFa__collapsedAccountWrapper",
  "fullWidth": "SidebarAccount-module__tbYnFa__fullWidth",
  "userInfo": "SidebarAccount-module__tbYnFa__userInfo",
  "userName": "SidebarAccount-module__tbYnFa__userName",
  "userRole": "SidebarAccount-module__tbYnFa__userRole",
  "userTriggerContent": "SidebarAccount-module__tbYnFa__userTriggerContent",
  "userTriggerLeft": "SidebarAccount-module__tbYnFa__userTriggerLeft",
});
